<!-- Add "scoped" attribute to limit CSS to this component only -->
import { setTimeout } from 'timers';
<style scoped lang="scss">
  @import "../utils.scss";
    $base-color:#79BD50;
  .address {
    height: px2rem(72px);
    display: flex;
    align-items: center;
    padding: 0 px2rem(20px);
    background: white;
    i {
      display: inline-block;
    }
    .address-info {
      flex:1;
      margin-left: px2rem(10px);
      .user {
        color: #333;
        @include font-dpr(16px);
        font-weight: bold;
        line-height: px2rem(20px);
      }
      .street {
        @include font-dpr(14px);
        color: #999;
        line-height: px2rem(20px);
      }
    }
    .pos-icon {
       height: px2rem(24px);
      width: px2rem(18px);
      background: url("../assets/icon_ads@2x.png") no-repeat;
      background-size: contain;
    }

    .more-icon {
      height: px2rem(15px);
      width: px2rem(15px);
      background: url("../assets/icon_arrow@2x.png") no-repeat;
      background-size: contain;
      float: right;
    }

  }

  .bar {
    background: url("../assets/icon_bar@2x.png");
    height: px2rem(3px);
  }

  .goods-list {
      margin-top: px2rem(10px);
      padding-left: px2rem(20px);
      background: white;
      .name {
        border-bottom: 1px solid #e5e5e5;
        @include font-dpr(16px);
        color: #333;
        height: px2rem(44px);
        line-height: px2rem(44px);
      }

      ul {
        padding-bottom:1px;
        border-bottom: 1px solid #e5e5e5;
      }
  }

  .cart-item {
        @include font-dpr(14px);
        color: #666;
        margin-top: px2rem(16px);
        padding: 0 px2rem(20px) 0  0 ;
        &:last-child {
            margin-bottom: px2rem(16px);
         }


         .quantity {
            float: right;
           width: px2rem(50px);
         }

         .price {
            float: right;
            width: px2rem(50px);
           text-align: right;
         }
    }

  .delivery-fee, .total-fee {
      display: flex;
      justify-content: space-between;
      height: px2rem(44px);
      border-bottom: 1px solid #e5e5e5;
    .value {
      @include font-dpr(14px);
      color: #666;
      line-height: px2rem(44px);
      margin-right: px2rem(20px);
    }
  }
  .total-fee .value {
    @include font-dpr(20px);
    color: $base-color;
  }

  .order-info {
    margin-top: px2rem(10px);
    margin-bottom: px2rem(10px);
    padding-left: px2rem(20px);
    background: white;
    .delivery-time, .order-notes {
      @include font-dpr(14px);
      color: #666;
      display: flex;
      align-items: center;
      min-height: px2rem(44px);
      line-height: px2rem(44px);

    }
    .delivery-time {
      .name {
        flex: 1;
      }
      .value {
        margin-right: px2rem(20px);
      }
    }

    .order-notes {
      input {
        flex: 1;
        margin-left: px2rem(16px);
        &::-webkit-input-placeholder {
          color:#ccc;
         }
      }
      .value{
        float:right;
        line-height: 1.2;
         margin-right: px2rem(20px);
            flex: 1;
          text-align: right;
      }
    }
    .more-select {
        display: inline-block;
      height: px2rem(18px);
      width: px2rem(18px);
      background: url("../assets/icon_arrow@2x.png") no-repeat;
      background-size: contain;
    }
  }
  .order-status-band {
    margin-top: px2rem(10px);
    margin-bottom: px2rem(48px);
    padding-left: px2rem(20px);
    background: white;
    @include font-dpr(14px);
    color: #666;
    display: flex;
    align-items: center;
    height: px2rem(44px);
    line-height: px2rem(44px);
    .status {
      width: 100%;
      display: flex;
      .name {
        flex: 1;
      }
      .value {
        font-weight: bold;
        margin-right: px2rem(20px);
      }
    }
  }

  .first-order {
     margin-top: px2rem(10px);
      padding-left: px2rem(20px);
      background: white;
    @include font-dpr(14px);
    height: px2rem(44px);
      line-height: px2rem(44px);
      .back {
        float: right;
        background: #c0c0c0;
        border-radius: px2rem(24px);
        height:px2rem(24px);
        width: px2rem(50px);
        margin-right: px2rem(20px);
        margin-top: px2rem(10px);
        border:1px solid #c0c0c0;
      }
      .ball {
        display: inline-block;
        background: white;
        height: px2rem(24px);
        width: px2rem(24px);
        border-radius: px2rem(24px);
        vertical-align: top;

      }
      .ball-check {
        background: $base-color;
        border:1px solid $base-color;
        .ball {
          float: right;
        }
      }

  }
   .bottom-options{
    position: fixed;
    bottom:0;
    z-index: 99;
    height: px2rem(48px);
    width: 100%;
    background: white;
    @include font-dpr(18px);
    box-shadow: 0 px2rem(-2px) px2rem(4px) 0 rgba(0,0,0,0.10);
    display: flex;
    align-items: center;
     .total {
       flex:1;
       margin-left: px2rem(20px);
       .total-name {
         vertical-align: middle;
       }
     }
     .price {
       @include font-dpr(24px);
       color: $base-color;
       vertical-align: middle;
     }
  }

  .place-order{
      float:right;
    @include font-dpr(18px);
      width: px2rem(134px);
      border:0;
      height: 100%;
      line-height:  px2rem(48px);
      background: $base-color;
      color: white;
    font-weight: bold;
    }

  .order-status {
      @include font-dpr(16px);
    color:#999;
    line-height: px2rem(48px);
    text-align: center;
    width: 100%;
  }

  .order-to-pay {
      text-align: right;
      width: 100%;
      padding-right: px2rem(20px);
      span{
        display: inline-block;
        height: px2rem(32px);
        border-radius: px2rem(4px);
        padding: 0 px2rem(24px);
        line-height: px2rem(32px);
        @include font-dpr(16px);
      }

      .cancel {
        border: 1px solid #e5e5e5;
        color: #333;
        margin-right: px2rem(12px);
      }
      .pay {
        background: $base-color;
        color: white;
      }
  }

  .order-404 {
      text-align: center;
      color: #666;
      @include font-dpr(14px);
      line-height: px2rem(30px);
  }
  [v-cloak] {
    display: none;
  }
</style>
<template>
  <div class="wrapper">
    <div v-if="!order && orderFound" class="order-404">
      抱歉，没有查到相关订单
    </div>
    <div class="checkout" v-if="order">
    <div class="address">
        <i class="pos-icon"></i>
        <div class="address-info" v-if="address.name">
          <p class="user">
            <span class="name">{{address.name}}</span>
            <span class="tel">{{address.tel}}</span>
          </p>
          <p class="street">
            {{address.street}}
          </p>
        </div>
    </div>
        <p class="bar"></p>
    <div class="goods-list">
        <div class="name">商品清单</div>
        <ul v-cloak>
          <li v-for='g in order.products' :key="g.name+g.spec">
            <p class="cart-item">
              <span>{{g.name}}{{g.spec ? ` [${g.spec}]`:""}}</span>
              <span class="price">¥{{Math.round( 100 * g.quantity * g.price)/100}}</span>
              <span style="float:right" v-if="g.unit2">({{g.quantity/(Number((g.unit2 && g.priceTransfer || 1)))}}{{g.unit2 || '份'}})</span>
              <span class="quantity">&nbsp;&nbsp;&nbsp;&nbsp;{{g.quantity}}{{g.unit || '斤'}}</span>
              <span style="float: right; color: red" v-if="g.suppliers && g.suppliers[0] && g.suppliers[0] !== order.supplier">{{supplierMap[g.suppliers[0]]}}</span>
             </p>
          </li>
        </ul>
        <div class="delivery-fee"><span class="name">配送费</span><span class="value">¥0</span></div>
        <div class="total-fee"><span class="name">总计</span><span class="value">¥{{roughPrice}}</span></div>
    </div>

    <div class="order-info">
        <div class="delivery-time">
          <span class="name">配送时间</span>
          <span class="value">{{order.dueTime}}</span>
        </div>
        <div class="order-notes" v-if="order.notes">
          <span class="name">订单备注</span>
          <span class="value">{{order.notes}}</span>
        </div>
        <div class="delivery-time">
            <span class="name">订单编号</span>
            <span class="value">{{order._id}}</span>
        </div>
        <div class="delivery-time" v-if="order.createTime">
            <span class="name">下单时间</span>
            <span class="value">{{order.createTime | filterTime}}</span>
        </div>
    </div>

    <div class="order-status-band">
      <div class="status">
            <span class="name">订单状态</span>
            <span class="value">{{STATUS_MAP[order.status]}}</span>
      </div>
    </div>
  </div>
  </div>

</template>

<script>
import { host } from '../config'

import utilMixin from './mixins/utils'
import { debug } from 'util';
export default {
  name: 'hello',
  mixins: [utilMixin()],
  data() {
    return {
      order: {},
      suppliers: [],
      orderFound: 0,
      STATUS_MAP: {
        '-1': '已取消',
        1: "待核对",
        2: '已核对',
        3: '已完成'
      },
    };
  },
  computed: {
    address() {
        return this.order && this.order.address || {};
    },
    roughPrice() {
      let result = 0
      this.order.products && this.order.products.forEach(g => {
        result += Math.round( 100 * g.quantity * g.price)/100
      })
      return result
    },
    supplierMap() {
      const map = {}
      this.suppliers.forEach(s => {
        map[s._id] = s.name
      })
      return map
    }
  },

  created() {
    this.$http.get(host + '/api/supplier/list', {withCredentials: true}).then(res => {
      this.suppliers = res.data.data
    })
    this.getOrder()

  },

  methods: {
    getOrder() {
      this.$http.get(host + '/api/order/'+this.$route.params.id).then(res=>{
        this.order = res.data.data
      });
    },
    
  }

};
</script>





// WEBPACK FOOTER //
// DeliveryOrderDetail.vue?0360e3c0